// 环境配置主文件
// 根据 REACT_APP_ENV 环境变量加载对应的环境配置

import { REACT_APP_ENV } from "../env";
import * as devConfig from "./environment.dev";
import * as testConfig from "./environment.test";
import * as prodConfig from "./environment.prod";
import type { Environment } from "./types";

// 获取环境变量，默认为 prod
const currentEnv = REACT_APP_ENV || 'prod';

let environment: Environment;

// 使用静态导入避免 webpack 动态依赖警告
switch (currentEnv) {
  case 'dev':
    environment = devConfig.default;
    console.log('🔧 加载开发环境配置');
    break;
  case 'test':
    environment = testConfig.default;
    console.log('🧪 加载测试环境配置');
    break;
  case 'prod':
  default:
    environment = prodConfig.default;
    console.log('🏭 加载生产环境配置');
    break;
}

// 在非 prod 环境下，如果配置文件中的 featureTag 为空，则读取 localStorage 的 featureTag
if (currentEnv !== 'prod') {
  if (!environment.featureTag) {
    const localFeatureTag = localStorage.getItem('featureTag');
    if (localFeatureTag) {
      environment = {
        ...environment,
        featureTag: localFeatureTag
      };
      console.log('📝 使用 localStorage 中的 featureTag:', localFeatureTag);
    }
  } else {
    console.log('📝 使用配置文件中的 featureTag:', environment.featureTag);
  }
}

export default environment;
export type { Environment } from "./types";
